import { render, staticRenderFns } from "./balance_report.vue?vue&type=template&id=12b7be17&scoped=true"
import script from "./balance_report.vue?vue&type=script&lang=js"
export * from "./balance_report.vue?vue&type=script&lang=js"
import style0 from "./balance_report.vue?vue&type=style&index=0&id=12b7be17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b7be17",
  null
  
)

export default component.exports